<template>
  <AccountPageWrapper>
    <nuxt />
  </AccountPageWrapper>
</template>

<script>
import AccountPageWrapper from '~/components/account-page-wrapper'

export default {
  middleware: ['fetchUser', 'publicOnly', 'applicationForm'],

  components: {
    AccountPageWrapper
  }
}
</script>

<style lang="scss" scoped>
</style>
